<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
      <el-breadcrumb-item>Generation</el-breadcrumb-item>
      <el-breadcrumb-item>Property-based</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="content">The Property-based module implements a conditional recurrent neural
        network for physicochemical property-guided molecular generation. Users can define
        target ranges for molecular descriptors, which are encoded as conditional inputs to
        guide generation. The current implementation supports commonly used physicochemical
        properties, including MW, LogP, TPSA, HBA, HBD, and QED. The results include generated
        SMILES and their associated property values.</p>

    <!-- 表单 -->
    <property-based-form></property-based-form>
    <!-- reference -->
  </div>
</template>

<script>
import PropertyBasedForm from "@/components/PropertyBasedForm";

export default {
  name: "PropertyBased",
  components: {PropertyBasedForm},
  data() {
    return {
      tableData: [
        { p:'Molecular Weight',
          d1:'The range of Molecular Weight of the generated molecules',
          d2:'300-500',
          r:'Based on Lipinski\'s Rule of Five (RO5) [1] and Drug-Like Soft rule, the Molecular Weight is ranged from 100 to 600.'
        },
        { p:'logP',
          d1:'n-octanol/water distribution coefficient of molecule (logP) possesses a leading position with considerable impact on both membrane permeability and hydrophobic binding to macromolecules [2].',
          d2:'0-5',
          r:'The larger the logP, the more lipophilic the compound is, and conversely, the smaller it is, the more hydrophilic it is.'
        },
        { p:'QED',
          d1:'quantitative estimate of drug-likeness (QED), a measure of drug-likeness by integrating Molecular Weight, logP, number of hydrogen-bonded acceptors, and number of hydrogen-bonded donors, polar surface area (PSA), number of rotatable covalent bonds, the number of aromatic rings, and the number of alerts for undesirable functional groups',
          d2:'0.4-1.0',
          r:'The larger the QED, the more attractive the compound is.'
        },
        { p:'TPSA',
          d1:'topological polar surface area (TPSA) is defined as the surface sum over all polar atoms or molecules, PSA is a metric for the optimization of a drug\'s ability to permeate cells.',
          d2:'0-140',
          r:'based on Veber rule [3]'
        },
        { p:'HBA',
          d1:'The number of hydrogen bonded acceptors',
          d2:'0-10',
          r:'Based on Lipinski\'s Rule of Five (RO5) the number of hydrogen bonded acceptors is ranged from 0 to 10.'
        },
        { p:'HBD',
          d1:'The number of hydrogen bonded donors',
          d2:'0-5 Lipinski, C.A. 2002. Physicochemical propertiesand the discovery of orally active drugs: Tech-nical and people issues.InMolecular Infor-matics: Confronting Complexity (M.G. Hicksand C. Kettner, eds.) pp. 1-20. Proc. Beilstein-Institute Workshop, May 13-16, 2002, Bozen,Italy.',
          r:'Based on Lipinski\'s Rule of Five (RO5) the number of hydrogen bonded donors is ranged from 0 to 5.'
        },
      ]
    }
  }

}
</script>

<style scoped>
div {
  max-width: 1160px;
  margin: 0 auto;
}

p {
  /*padding: 20px 0 20px;*/
  line-height: 1.5em;
  text-align: left;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
